import { Path, PointText, Tool, Point, Color } from 'paper';
import store from '../store';
import PathStyle from '@/services/PathStyle';
import ToolsUtils from '../services/ToolsUtils';
import { MaterialSvg } from '../shapes/toolshapes/MaterialSvg';
import { CutSvg } from '../shapes/toolshapes/CutSvg';
import paper from 'paper';

let local = {
    path: null,
    defaultProportion: 1,
    defaultContent: 'M755.188 64c-107.63 0-200.258 87.554-243.164 179-42.938-91.444-135.578-179-243.216-179-148.382 0-268.808 120.44-268.808 268.832 0 301.846 304.5 380.994 512.022 679.418 196.154-296.576 511.978-387.206 511.978-679.418 0-148.392-120.43-268.832-268.812-268.832z',
    position : null
};

function onMouseDown(event) {
    if (event.event.button > 0) {
        store.dispatch('setWhiteboardTool', 'selecter');
        event.preventDefault();
        event.stopPropagation();
        return false;
    }

    let defaultSize = ToolsUtils.defaultSize(local.defaultProportion, event);

    local.path = new Path.Rectangle(
        ToolsUtils.boundingRectangle(event.point, defaultSize)
    );

    PathStyle.transform(local.path);
    store.dispatch('setToolSelected', false);

    local.path.removeOnDrag();
    local.path.removeOnUp();
}

function onMouseDrag(event) {
    local.path = new Path.Rectangle(
        ToolsUtils.boundingRectangle(event.downPoint, event.point)
    );

    mousetip(event, 'L : ' + Math.round(Math.abs(event.point.x - event.downPoint.x)) + ' mm\nH : ' + Math.round(Math.abs(event.point.y - event.downPoint.y)) + ' mm');

    PathStyle.transform(local.path);

    local.path.removeOnDrag();
    local.path.removeOnUp();
}

async function onMouseUp(event) {

    let boundingRectangle = ToolsUtils.boundingRectangle(event.downPoint, event.point);

    let defaultSize = ToolsUtils.defaultSize(local.defaultProportion, event);
    if (ToolsUtils.isClic(event)) boundingRectangle.size = defaultSize;
    if(!store.getters.shapes.length) boundingRectangle = ToolsUtils.setToOrigin(boundingRectangle, event);
    local.position = boundingRectangle;
    store.dispatch('openIconsChoice', true);    
}

function mousetip(event, content) {
    let item = paper.project.getItem({name: 'mousetip'});

    if (!item) {
        item = new PointText(event.point);
        item.name = 'mousetip';
        item.style = {
            fontFamily: 'Open Sans',
            fontWeight: 'bold',
            fontSize: store.getters.mobile ? 20 / store.getters.zoom : 15 / store.getters.zoom,
            fillColor: '#59ABFF',
            justification: 'center',
            shadowColor: new Color(1, 1, 1),
            shadowBlur: 10 / store.getters.zoom,
            shadowOffset: new Point(0, 0)
        };
    }
    item.content = content;
    if (store.getters.mobile)
    {
        item.point = store.getters.center.add(new Point(0, -300 / store.getters.zoom));
    }
    else
    {
        item.point = event.point.add(
            new Point((20 / store.getters.zoom) + (item.bounds.width / 2), -20 / store.getters.zoom)
        );
    }
}

async function displayIcon() {

    let shape;
    let content = store.getters.svgPattern;
    let name = store.getters.svgName;
    let boundingRectangle = local.position;

    if (store.getters.toolType == 'cut') {
        shape = new CutSvg(
        boundingRectangle,
        content,
        name
    );
    } else {
        shape = new MaterialSvg(
        boundingRectangle,
        content,
        name
    );}
    await shape.updatePath();

    store.dispatch('addToolShape', shape);
    store.dispatch('setDropped', null);

    local.path = null;
    store.dispatch('setSvgPattern',null);
    store.dispatch('setSvgName',null);
    
    
}

export const SvgTool = new Tool({
    name: 'svg',
    onMouseDown,
    onMouseDrag,
    onMouseUp,
    displayIcon
});
